import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import { LoaderEvent } from './../../shared/message.event';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-view-groups',
  templateUrl: './view-groups.component.html',
  styleUrls: ['./view-groups.component.css'],
  providers: [LoaderEvent],
  exportAs: 'ViewGroups'
})
export class ViewGroupsComponent implements OnInit {
  @ViewChild('childModal') childModal: ModalDirective;
  @Input() message = '';
  @Input() popupTitle;
  @Input() cancleButton;
  // @Output() notify: EventEmitter<string> = new EventEmitter<string>();
  @Output() notify = new EventEmitter<boolean>();
  @Output() notifyDelete = new EventEmitter<boolean>();
  @Input() deleteMessage;
  @Input() tempFacilityId;
  @Input() groupList;
  public onsamePage = 0;
  @Output() facilityid = new EventEmitter<string>();
  @Input() history;
  @Output() removeGroup = new EventEmitter<any>();
  constructor(private router: Router, private loaderEvent: LoaderEvent) {
  }

  public showChildModal(): void {
    try {
      this.childModal.config.backdrop = false;
      this.childModal.show();
    } catch (e) {
      console.log(e);
    }
  }

  public hideChildModal(): void {
    try {
      this.childModal.hide();
    } catch (e) {
      console.log(e);
    }
  }

  ngOnInit() {
  }
/**
 * Remove item from list
 * 
 * @param {any} group 
 * 
 * @memberof ViewGroupsComponent
 */
  removeFromSelection(group) {
    this.removeGroup.emit(group);
    if (this.groupList.length === 0) {
      this.childModal.hide();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/feed/view-groups/view-groups.component.ts